module.exports = "<div class=\"container\">\r\n\t<h1>Stránka neexistuje.</h1>\r\n\t<p>\r\n\t\tPřejít zpět na hlavní stranu Manažera prodeje.\r\n\t</p>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/p404.component.html
// module id = 463
// module chunks = 11